module.exports = __webpack_public_path__ + "img/twitter.7a54bf63.svg";